import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { CommonService } from 'src/app/services/common.service';
import { environment } from 'src/environments/environment';
import { SendMoneyService } from '../send-money/send-money.service';

@Injectable({
  providedIn: 'root'
})
export class RequestMoneyService {
  isRequestChecked=true
  isFormChecked=false
  isConfirmChecked=false
  isCompleteChecked=false
  step1Data
  step2Data
  step3Data
  requestMethods=[]
  reasons=[]
  constructor(public router:Router,public http:HttpClient,public messageService:MessageService,public sendMoneyService:SendMoneyService,public common:CommonService) {
    this.setReasons()
   }

  goTo(stepName){
    if(stepName=='step1'){
      this.isRequestChecked=true
      this.isFormChecked=false
      this.isConfirmChecked=false
      this.isCompleteChecked=false
      this.router.navigateByUrl("/request-money/step1")
    }
    if(stepName=='step2'){
      this.isRequestChecked=true
      this.isFormChecked=true
      this.isConfirmChecked=false
      this.isCompleteChecked=false
      this.router.navigateByUrl("/request-money/step2")
    }
    if(stepName=='step3'){
      this.isRequestChecked=true
      this.isFormChecked=true
      this.isConfirmChecked=true
      this.isCompleteChecked=false
      this.router.navigateByUrl("/request-money/step3")
    }
    if(stepName=='step4'){
      this.isRequestChecked=true
      this.isFormChecked=true
      this.isConfirmChecked=true
      this.isCompleteChecked=true
      this.router.navigateByUrl("/request-money/step4")
    }
  }


  setRequestMethods(){
    //console.log("inside set")
    this.http.post(environment.api_link+'/api/auth/request_money',{}).subscribe((res:any)=>{
      //console.log(res)
      this.requestMethods=res.bank_details
    },err=>{
      //console.log(err)
    })
  }

  addRequestMethod(data){
    return this.http.post(environment.api_link+'/api/auth/save_request_bank_detail',data)
  }

  sendRequest(){
    let data = {user_bank_detail_id:this.step1Data.id,...this.step2Data}
    return this.http.post(environment.api_link+'/api/auth/send_request',data)
  }

  resetCheckedSteps(){
    this.isRequestChecked=true
      this.isFormChecked=false
      this.isConfirmChecked=false
      this.isCompleteChecked=false
  }

  setReasons(){
    this.common.showLoader()
    this.sendMoneyService.getcareason().subscribe((res:any)=>{
      //console.log(res)
      this.reasons=res.reasons
      //console.log(this.reasons)
      this.common.stopLoader()
    },err=>{
      let errorKeys = Object.keys(err.error.errors); 
        errorKeys.forEach(key => { 
          //console.log(key)
          let value = err.error.errors[key][0]; 
          this.messageService.add({severity:'error', summary:value, detail:""});
          //console.log(value); 
      }); 
      //console.log(err)
      this.common.stopLoader()
      })
  }

}
